import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';

import classes from './tagList.module.scss';

import ArrowSVG from '@/assets/svg/arrow-tags.svg';
import { Tag } from '@/components/UI/TagList/Tag';
import { tags } from '@/constants/tags';
import type { TagType } from '@/constants/tags';
import { useStorage } from '@/models/Storage';
import useMobile from '@/hooks/useMobile';
import { analytics, AnalyticsShow } from '@/utils/analytics';

export const TagList = observer(
    ({
        isTarget = false,
        customTags = Object.keys(tags),
        className = '',
        tagClassName = '',
        callback = () => {},
        foldable = false,
    }) => {
        const wrapperRef = useRef(null);
        const { selectedTags, addTag, removeTag } = useStorage();

        const tagClick = (value: string) => {
            if (selectedTags.includes(value)) {
                removeTag(value);
            } else {
                addTag(value);
                analytics(AnalyticsShow.Tags[value]);
            }
            callback();
        };

        const [folded, setFolded] = useState(true);
        const [fullHeight, setFullHeight] = useState(0);

        return (
            <div
                key={selectedTags.length}
                className={clsx(
                    classes.tagList,
                    isTarget && 'js-tag-target',
                    className && classes[className],
                    foldable && classes.foldable,
                    folded && classes.folded,
                )}
                style={{
                    height: !foldable ? 'auto' : `${folded ? '56px' : fullHeight + 'px'}`,
                }}
            >
                <div
                    className={classes.wrapper}
                    ref={(el: HTMLDivElement) => {
                        if (el) {
                            setFullHeight(el?.getBoundingClientRect().height);
                        }
                    }}
                >
                    {customTags.map((key) => {
                        const tag = tags[key];
                        return (
                            <Tag
                                text={tag}
                                value={key}
                                selected={selectedTags?.includes(key)}
                                key={key}
                                callback={tagClick}
                                className={tagClassName}
                            />
                        );
                    })}
                    {foldable && (
                        <ArrowSVG
                            onClick={() => {
                                setFolded(!folded);
                            }}
                            className={classes.arrow}
                        />
                    )}
                </div>
            </div>
        );
    },
);
